<template>
<div class="container" style="margin-bottom: 100px; padding-top: 90px; padding-bottom: 90px; text-align: center;">
    <h3>{{ $t("solutionsH") }}</h3>
    <div class="row">
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'PmLanding', params: {}}">
                     <div class="pad">
                        <img src="@/assets/Solutions/home.png" style="width: 80px;" alt="">
                        <h5 style="font-weight: 500; padding-top: 40px;">{{ $t("pM") }}</h5>
                    </div>
                </router-link> 
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'RmLanding', params: {}}">
                    <div class="pad">
                        <img src="@/assets/Solutions/screen.png" style="width: 80px;" alt="">
                        <h5 style="font-weight: 500; padding-top: 40px;">{{ $t("rM") }}</h5>
                    </div>
                </router-link>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'BookEngine', params: {}}">
                    <div class="pad">
                        <img src="@/assets/Solutions/book.png" style="width: 80px;" alt="">
                        <h5 style="font-weight: 500; padding-top: 40px;">{{ $t("bE") }}</h5>
                    </div>
                </router-link>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'AppLanding', params: {}}">
                    <div class="pad">
                        <img src="@/assets/Solutions/phone.png" style="width: 80px;" alt="">
                        <h5 style="font-weight: 500; padding-top: 40px;">{{ $t("aPp") }}</h5>
                    </div>
                </router-link>
            </div>
             <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <router-link style="text-decoration: none; color: #2c3e50;" :to="{ name: 'ExtraModulesLanding', params: {}}">
                    <div class="pad">
                        <img src="@/assets/Solutions/note.png" style="width: 80px;" alt="">
                        <h5 style="font-weight: 500; padding-top: 40px;">{{ $t("eM") }}</h5>
                    </div>
                </router-link>
            </div>
        </div>
</div> 
</template>

<script>

export default {
  name: 'Solutions',
  data(){
      return{
          catList: [],
          val: 4,
          img: 'https://static.zuniac.com/language/photo/',
        }
  },
  async mounted(){
  },

  methods : {
     
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.pad{
    background: #f7f9fc;; 
    padding: 40px; 
    border-radius: 5px; 
    height: 255px;
}

.pad:hover{
    margin-top: -5px !important;
    transition: 350ms;
    box-shadow: 0px 10px 20px 2px #bbb8b8;
}


</style>
